<template>
	<div v-if="isLoaded">		
			<v-select :options="assessmentnames" label="title" placeholder="Select Assessment Name"  v-model="selected" @change="onChange()" id="selected">
			<option>
				{{ assessmentnames }}
			</option>
		</v-select>
	</div>
	<div v-else-if="!isLoaded">
		<form class="ui form">
			<input  placeholder="Loading assessment" class="loading" type="text" style="background-color: #eee;" disabled>
		</form>
	</div>
</template>

<script>
	import axios from "axios";
	import { bus } from '../../main.js';
	export default {
		data: function () {
			return {
				assessmentnames: [],
				selected: '',
				isLoaded: false,
				iserror : false,
			};
		},
		mounted() {
			this.pullassessment()
		},
		methods: {
			pullassessment() {
				let access_token = this.$route.query.access_token
				axios.request({
					method: "get",
					baseURL: "https://utilities.talview.com/api/models/assessment?hasLiveSection=true",
					headers: {
            			Authorization: `Bearer ${access_token}`
          	},
				}).then(response => {
					this.isLoaded = true;
					this.assessmentnames = response.data
				}).catch(error => {
					this.isLoaded = false;
					this.iserror = true;
					console.log("Error is", error)
					Vue.$toast.open({
							message: 'Something went wrong Please try again',
							type: 'error',
							queue: true,
							dismissible: true,
							autoDismiss: true
						})
				});
			},
			onChange() {
				console.log("value")
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/assessmentname.vue